import KpiCard from '../../organisms/KpiCard/KpiCard';
import { useSelectedAsset, useSelectedEvent } from '../../../lib/util';
import { useCarousel, Button, CarouselSlider, CarouselPagination } from '@bphxd/ds-core-react';
import { Left24, Right24 } from '@bphxd/ds-core-react/lib/icons';

import { useKpiMetrics } from './KpiSection.util';

const KpiSection = () => {
  const asset = useSelectedAsset();
  const { event } = useSelectedEvent();

  const kpiMetrics = useKpiMetrics(asset, event);

  const SLIDES_PER_PAGE = 5;

  const { activeIndex, pageCount, sliderRef, next, prev, goTo, sliderSettings } = useCarousel({
    easing: 'ease',
    speed: 250,
    draggable: false,
    slidesToShow: SLIDES_PER_PAGE,
    slidesToScroll: 1,
    infinite: false,
  });

  return (
    <div className="my-4">
      <CarouselSlider className="mb-4" ref={sliderRef} {...sliderSettings}>
        {Object.values(kpiMetrics).map((card, index) => (
          <div className="px-4" key={index}>
            <KpiCard
              title={card.title}
              subtitle={card.subtitle}
              completionCount={card.completionCount}
              totalCount={card.totalCount}
              loading={card.loading}
              error={card.error}
              target={card.target}
            />
          </div>
        ))}
      </CarouselSlider>
      <div className="d-flex justify-content-center">
        <CarouselPagination length={pageCount} activeIndex={activeIndex} goTo={goTo} />
      </div>
      <div className="d-flex justify-content-end mx-4">
        <Button
          color="standard-outline"
          className="btn-square rounded-0"
          onClick={prev}
          disabled={!sliderSettings.infinite && activeIndex === 0}
        >
          <Left24 className="absolute-center" />
        </Button>
        <Button
          color="standard-outline"
          className="btn-square rounded-0 ms-4"
          onClick={next}
          disabled={!sliderSettings.infinite && activeIndex === pageCount - 1}
        >
          <Right24 className="absolute-center" />
        </Button>
      </div>
    </div>
  );
};

export default KpiSection;
